<div class="wrapper">
  <!-- <app-language-switcher></app-language-switcher> -->
  @if(tenantReady){ <app-header />
  <router-outlet (activate)="scrollToTop()" />
  <app-footer />
  }

  @if(false){
  <div class="consent-banner">
    <div>
      <!-- <span class="h-close"></span> -->
      <h2>{{ 'Consent banner' | translate }}</h2>
      <p><span>{{ 'This website uses cookies. By using this website, you agree to the use of cookies. For More Info Read
          our' | translate }}</span><a routerLink="privacy-policy">{{ 'Policy' | translate }}</a>. </p>
      <a class="agreed-btn">{{ 'Agree' | translate }}</a>
    </div>
  </div>
  }
</div>